<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Redeem</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Redeem</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>The page allow to view any redeems.</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="vendor" class="">
              <div class="row">
                <div class="col-12 col-lg-6 col-sm-12">
                  <h4 class="card-title mb-3">
                    Redeem
                  </h4>
                </div>

                <div class="col-12 col-lg-6 col-sm-12 align-items-center">
                  <h4 class="card-title mb-3 text-right">
                    Total Points Redeemed <br />
                    {{ total_points_redeemed }}
                  </h4>

                  <h4 class="card-title mb-3 text-right">
                    Total Price Used Vouchers <br />
                    $ {{ total_price_vouchers_used }}
                  </h4>
                </div>
              </div>

              <!-- For filters -->
              <div class="row">
                <!-- Month -->
                <!-- <div class="col-6">
                  <div class="form-group">
                    <label>Month</label>
                    <select class="form-control" v-model="filter_month">
                      <option
                        v-for="(month, index) in months"
                        :key="index"
                        :value="index"
                        >{{ month }}</option
                      >
                    </select>
                  </div>
                </div> -->

                <!-- Year -->
                <!-- <div class="col-6">
                  <div class="form-group">
                    <label>Year</label>
                    <select class="form-control" v-model="filter_year">
                      <option v-for="(year, index) in years" :key="index">{{
                        year
                      }}</option>
                    </select>
                  </div>
                </div> -->

                <!-- Filter date by from and to -->
                <div class="col-6">
                  <label><b>Redeemed Date From</b></label>
                  <input type="date" class="form-control" v-model="dateFrom" />
                </div>
                <div class="col-6">
                  <label><b>Redeemed Date To</b></label>
                  <input type="date" class="form-control" v-model="dateTo" />
                </div>

                <br />

                <!-- Redeemed By -->
                <div class="col-6 pt-2 pb-4">
                  <div class="form-group">
                    <label><b>Redeemed By</b></label>
                    <select class="form-control" v-model="filter_redeemed_by">
                      <option
                        v-for="(vendor, index) in vendor_filters"
                        :key="index"
                        :value="vendor.user_id"
                      >
                        <span>{{ vendor.account_number }}</span>
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Submit filter -->
                <div class="col-6 pt-2 pb-4">
                  <div class="form-group">
                    <button class="btn btn-primary" @click="applyFilter()">
                      Filter
                    </button>
                    &nbsp;
                    <button
                      id="btnAll"
                      class="btn btn-primary d-none"
                      @click="removeFilter()"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              <div class="text-left pb-4">
                {{
                  dateFromFormatted != null && dateToFormatted != null
                    ? `Report Date from ${dateFromFormatted} to ${dateToFormatted}`
                    : ""
                }}
              </div>

              <!-- Vendor -->
              <div class="table-responsive">
                <table
                  id="vendor_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Redeemed By</th>
                      <th>Product</th>
                      <th>Prices ($)</th>
                      <th>Used Date</th>
                      <th>Redeemed Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(redeem, index) in redeems" v-bind:key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <span> {{ redeem.account_number }}</span>
                      </td>
                      <td>{{ redeem.vendor_product }}</td>
                      <td>{{ redeem.price_redeemed }}</td>
                      <td>
                        <span v-if="redeem.voucher_used_at != null">
                          {{
                            redeem.voucher_used_at
                              | moment("Do MMMM YYYY, h:mm a")
                          }}
                        </span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        {{
                          redeem.redeemed_at | moment("Do MMMM YYYY, h:mm a")
                        }}
                      </td>

                      <td>
                        <router-link
                          class="btn btn-primary btn-rounded btn-block"
                          :to="action(redeem.id)"
                        >
                          View Details
                        </router-link>

                        <!-- <button class="btn btn-success btn-rounded btn-block" @click="refund(vendor.id)">
                              Refund
                          </button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";

export default {
  name: "vendor-redeem-view",
  components: {},

  data() {
    return {
      redeems: [],
      charities: [],
      vendor_filters: [],

      total_points_redeemed: 0,
      total_price_vouchers_used: 0,

      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      years: [],

      // filter_month: "",
      // filter_year: "",

      dateFrom: null,
      dateTo: null,
      dateFromFormatted: null,
      dateToFormatted: null,

      filter_redeemed_by: ""
    };
  },

  methods: {
    loadVendors() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/point/redeem/all?type=1", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.redeems = res.data.redeems;
            this.total_points_redeemed = res.data.total_points_redeemed;
            this.total_price_vouchers_used = res.data.total_price_vouchers_used;
            this.vendor_filters = res.data.grouped;
          })
          .then(function() {
            $("#vendor_tbl").DataTable({
              pageLength: 10,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadVendors();
    },

    destroyDatatable() {
      $("#vendor_tbl")
        .DataTable()
        .destroy();
    },

    action(id) {
      return "/redeem/summary/" + id;
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      // Destroy Table
      this.destroyDatatable();

      // Declare filters
      let redeemed_by = "";
      let date_from = "";
      let date_to = "";
      // let year = "";
      // let month = "";

      // if (this.filter_month.length != 0) {
      //   month = "&filter_month=" + (this.filter_month + 1);
      // }

      // if (this.filter_year.length != 0) {
      //   year = "&filter_year=" + this.filter_year;
      // }

      if (this.dateTo != null && this.dateFrom != null) {
        this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
        this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

        date_from = "&date_from=" + this.dateFrom;
        date_to = "&date_to=" + this.dateTo;
      }

      if (this.filter_redeemed_by.length != 0) {
        redeemed_by = "&filter_redeemed_by=" + this.filter_redeemed_by;
      }

      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      this.vendors = [];
      this.total = 0;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL +
              "/point/redeem/all?type=1" +
              date_from +
              date_to +
              redeemed_by,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.redeems = res.data.redeems;
            this.total_points_redeemed = res.data.total_points_redeemed;
            this.total_price_vouchers_used = res.data.total_price_vouchers_used;
            this.vendor_filters = res.data.grouped;
          })
          .then(function() {
            $("#vendor_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_month = "";
      this.filter_year = "";
      this.filter_redeemed_by = "";

      this.vendors = [];
      this.total = 0;

      this.destroyDatatable();
      this.loadVendors();
    },

    refund(id) {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (!confirm) {
            return;
          }

          axios
            .post(
              axios.lpsURL + "/point/refund",
              {
                redeem_id: id
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              }
            )
            .then(res => {
              if (res.data.success) {
                swal({
                  icon: "success",
                  text: res.data.message
                }).then(ok => {
                  this.loadData();
                });
              } else {
                swal({
                  icon: "error",
                  text: res.data.message
                });
              }
            });
        });
      }
    }
  },

  mounted() {
    this.loadData();
    this.loadYearFilter();
  }
};
</script>
